import * as React from "react"

import "./App.css"
import { observer } from "mobx-react"
import { observable } from "mobx"
import { BookingFlow } from "BookingSystem/BookingFlow"
import { General } from "BookingSystem/steps/General/GeneralStepComp"
import { MembersStepComp } from "BookingSystem/steps/Members/MembersStepComp"
import { WaiversStepComp } from "BookingSystem/steps/Waivers/WaiversStepComp"
import { DayPickerStepComp } from "BookingSystem/steps/DayPicker/DayPickerComp"
import { PassesStepComp } from "BookingSystem/steps/Passes/PassesStepComp"
import { PayStepComp } from "BookingSystem/steps/Pay/PayStepComp"
import { NotReadyMessage } from "BookingSystem/NotReadyMessage"
import { ModalComp } from "BookingSystem/utils/ModalComponents/ModalComp"
import { MemberFormComp } from "BookingSystem/steps/Members/MemberFormComp"
import { DayPickerFormComp } from "BookingSystem/steps/DayPicker/DayPickerFormComp"

@observer
class App extends React.Component {
  @observable
  flow = new BookingFlow({
    general: General,
    members: MembersStepComp,
    waivers: WaiversStepComp,
    daypicker: DayPickerStepComp,
    passes: PassesStepComp,
    pay: PayStepComp,
    notReady: NotReadyMessage,
    modal: ModalComp,
    memberForm: MemberFormComp,
    daypickerForm: DayPickerFormComp
  })
  public render() {
    return this.flow.rootView
  }
}

export default App
